/**
 * NGXS Actions for Award Committee Meetings
 */

import {
    CreateAwardCommitteeMeetingRequest,
    CreateDeadlineRequest,
    UpdateAwardCommitteeMeetingRequest,
    UpdateDeadlineRequest
} from '../interfaces/award-committee-meeting.interface';

const prefix = '[AwardCommittee]';

// ==================== Meeting Actions ====================

export class LoadMeetings {
    static readonly type = `${prefix} Load Meetings`;
    constructor(
        public page = 0,
        public pageSize = 20
    ) {}
}

export class CreateMeeting {
    static readonly type = `${prefix} Create Meeting`;
    constructor(public request: CreateAwardCommitteeMeetingRequest) {}
}

export class UpdateMeeting {
    static readonly type = `${prefix} Update Meeting`;
    constructor(
        public id: string,
        public request: UpdateAwardCommitteeMeetingRequest
    ) {}
}

export class DeleteMeeting {
    static readonly type = `${prefix} Delete Meeting`;
    constructor(public id: string) {}
}

// ==================== Deadline Actions ====================

export class CreateDeadline {
    static readonly type = `${prefix} Create Deadline`;
    constructor(
        public meetingId: string,
        public request: CreateDeadlineRequest
    ) {}
}

export class UpdateDeadline {
    static readonly type = `${prefix} Update Deadline`;
    constructor(
        public meetingId: string,
        public deadlineId: string,
        public request: UpdateDeadlineRequest
    ) {}
}

export class DeleteDeadline {
    static readonly type = `${prefix} Delete Deadline`;
    constructor(
        public meetingId: string,
        public deadlineId: string
    ) {}
}
